export default function TestimonialsSection() {
  const testimonials = [
    {
      id: 1,
      title: '多忙な中でも、スムーズに実家の整理ができました',
      content: '東京で仕事をしながら、横浜の実家の整理をする必要がありました。買い取りかわせみ様にお願いしたところ、査定から買取、不用品の処分、清掃まで全てワンストップで対応していただき、何度も往復する手間が省けました。吉田様の丁寧な対応と、的確な査定に感謝しております。',
      name: '田中 様',
      location: '東京都在住（ご実家：横浜市）',
      rating: 5,
    },
    {
      id: 2,
      title: '相続品の価値を正確に評価していただきました',
      content: '父が遺した骨董品や時計の価値が分からず困っておりました。買い取りかわせみの吉田様は、一つ一つ丁寧に説明しながら査定してくださり、想像以上の金額で買い取っていただきました。古物商許可証をお持ちで、10年の経験がある方だからこその安心感がありました。',
      name: '佐藤 様',
      location: '神奈川県鎌倉市',
      rating: 5,
    },
    {
      id: 3,
      title: '母の気持ちに寄り添った対応に感動しました',
      content: '高齢の母が長年大切にしていた着物や宝飾品を手放す決断は、とても辛いものでした。吉田様は母の想い出話にも耳を傾けてくださり、「次の方に大切にしていただきます」という言葉に母も安心して託すことができました。単なる買取業者ではなく、心のこもったサービスでした。',
      name: '山田 様',
      location: '神奈川県藤沢市',
      rating: 5,
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-emerald-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-sm font-medium tracking-wider text-teal-700 uppercase">
              Customer Testimonials
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            お客様の声
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            ご実家の整理や相続品の買取で、買い取りかわせみをご利用いただいたお客様から<br />
            心温まるお言葉を頂戴しております。
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-amber-400 opacity-30"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>

              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-xl font-serif font-semibold text-gray-900 mb-4 leading-snug" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                {testimonial.title}
              </h3>

              {/* Content */}
              <p className="text-gray-700 leading-relaxed mb-6 text-base">
                {testimonial.content}
              </p>

              {/* Customer Info */}
              <div className="pt-6 border-t border-gray-200">
                <p className="font-semibold text-gray-900 mb-1">{testimonial.name}</p>
                <p className="text-sm text-gray-500">{testimonial.location}</p>
              </div>

              {/* Accent Border */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-teal-600 via-emerald-500 to-teal-600 rounded-b-lg"></div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-teal-50 to-emerald-50 px-8 py-4 rounded-full border border-teal-200">
            <i className="ri-shield-check-fill text-teal-700 text-2xl w-6 h-6 flex items-center justify-center"></i>
            <p className="text-gray-700 font-medium">
              お客様満足度 <span className="text-2xl font-bold text-teal-700 mx-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>98%</span> を達成
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}